function scrollToElement($el) {

	$('html, body').animate({
		scrollTop: ( $el.offset().top - $('header').height() )
	}, 500);

}
